$(document).ready(function(){
    if (typeof Flickity === 'undefined') {
        console.warn('Flickity not loaded');
        return;
    }
    let elem = document.getElementById('howitworks-carousel');
    if (elem) {
        let width = $(window).width();
        let align = 'center';
        if (width > 992) {
            align = 'left';
        }
        try {
            let flkty = new Flickity(elem, {
                cellAlign: align,
                contain: false,
                freeScroll: false,
                prevNextButtons: false,
                pageDots: true,
                percentPosition: true
            });
        } catch (e) {
            console.error('Error initializing Flickity:', e);
        }
    }

    $('[data-flickity]').each(function() {
        if (!$(this).data('flickity')) {
            try {
                let options = $(this).data('flickity');
                $(this).flickity(options);
            } catch (e) {
                console.error('Error initializing Flickity on element:', e);
            }
        }
    });
});